import { MouseEvent, ReactNode, useEffect, useRef } from "react";
import "./toggle.scss";

interface IToggle {
  text: string;
  children: ReactNode;
}

export default function ToggleBtn({ text, children }: IToggle) {
  const toggleRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);
  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    if (listRef.current && toggleRef.current) {
      const height = listRef.current.children[0].clientHeight;
      const styles = listRef.current.className;

      listRef.current.style.left =
        -toggleRef.current?.clientWidth / 2 + 8 + "px";

      if (styles.includes("visible")) {
        listRef.current.className = "";
        listRef.current.style.height = 0 + "px";
        toggleRef.current.children[0].className = "";
      }
      if (!styles.includes("visible")) {
        const button = toggleRef.current.children[0] as HTMLButtonElement;
        listRef.current.className = "visible";
        listRef.current.style.height = height + 10 + "px";
        button.className = "visible text-blue-300";
      }
    }
  };

  //OUTSIDE CLICK
  const outSideClick = (e: any) => {
    if (
      toggleRef.current &&
      !toggleRef.current.contains(e.target) &&
      listRef.current
    ) {
      listRef.current.className = "";
      listRef.current.style.height = 0 + "px";
    }
  };

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);

  return (
    <div className="toggle" ref={toggleRef}>
      <button type="button" onClick={handleToggle}>
        {text}
      </button>
      <div ref={listRef}>{children}</div>
    </div>
  );
}
